export const enum COOKIE_KEY {
  TOKEN = 'nks_code',
  EXPIRED = 'nks_expired',
  ACCESS_TOKEN = 'nks_token',
  REFRESH_TOKEN = 'refresh_token',
  REFRESH_EXPIRED = 'refresh_expired',
}
